const BackDrop = ({onClose}: {onClose: () => void}) => {
    return (
        <div
            className="fixed bottom-0 left-0 right-0 top-0
      z-5 bg-black/20 backdrop-opacity-5"
            onClick={onClose}></div>
    );
};

export default BackDrop;
